module.exports = __webpack_public_path__ + "ba36336eaa81a9fbc6842819098aa5e9.png";